import { type FetchUserTransactionHistorySummaryByTypeParams } from '@capsicum/common';

import { useUserTransactionHistoryLastQuery } from '../data-access/queries';

/**
 * @params 	FetchUserTransactionHistorySummaryByTypeParams
 * type : 'chz' | 'fan_token' | 'main';
 * @returns user transaction history paginated
 */
export const useUserTransactionHistorySummaryLast = (params: FetchUserTransactionHistorySummaryByTypeParams) => {
	return useUserTransactionHistoryLastQuery(params);
};
